"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Map = function Map(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon icon-no-fill ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 0.75,6.26c0-0.613,0.373-1.165,0.943-1.393l5.381-2.152C7.826,2.414,8.667,2.43,9.407,2.759l4.487,1.994 c0.71,0.315,1.514,0.343,2.244,0.078l5.1-1.855c0.778-0.283,1.639,0.118,1.923,0.897c0.06,0.165,0.091,0.338,0.09,0.513v13.308 c0,0.63-0.395,1.193-0.987,1.409l-6.125,2.228c-0.73,0.265-1.534,0.237-2.244-0.078l-4.488-1.994 c-0.74-0.329-1.581-0.345-2.333-0.044l-4.267,1.707c-0.769,0.308-1.642-0.067-1.95-0.836C0.786,19.909,0.75,19.72,0.75,19.529V6.26 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 12.375,11.244c0.207,0,0.375,0.168,0.375,0.375"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 12,11.619c0-0.207,0.168-0.375,0.375-0.375"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 12.375,11.994 c-0.207,0-0.375-0.168-0.375-0.375"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 12.75,11.619c0,0.207-0.168,0.375-0.375,0.375"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 9.375,13.75c0.207,0,0.375,0.168,0.375,0.375"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 9,14.125c0-0.207,0.168-0.375,0.375-0.375"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 9.375,14.5C9.168,14.5,9,14.332,9,14.125"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 9.75,14.125 c0,0.207-0.168,0.375-0.375,0.375"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 6.375,11.5c0.207,0,0.375,0.168,0.375,0.375"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 6,11.875C6,11.668,6.168,11.5,6.375,11.5 "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 6.375,12.25C6.168,12.25,6,12.082,6,11.875 "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 6.75,11.875c0,0.207-0.168,0.375-0.375,0.375 "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 4.125,14.5 c0.207,0,0.375,0.168,0.375,0.375 "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 3.75,14.875c0-0.207,0.168-0.375,0.375-0.375 "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 4.125,15.25c-0.207,0-0.375-0.168-0.375-0.375 "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 4.5,14.875c0,0.207-0.168,0.375-0.375,0.375 "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 15.75,8.244l4.5,4.5 "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 15.75,12.744l4.5-4.5"
  })));
};
Map.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Map.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Map;